<template>
  <div>
    <viewTable
      ref="viewTable"
      :limits="limits"
      :columns-property="columnsProperty"
      :filter="filter"
      module="basic"
      url="fm/workstation"
      @addOrEdit="addEditHandle"
      @delete="deleteHandle"
      @reset="resetHandle"
    >
      <template slot="adSearch">
        <el-form :inline="true" :model="filter" @keyup.enter.native="loadData(1)">
          <el-form-item label="工位编码">
            <el-input v-model.trim="filter.stationCode" placeholder="请输入工位编码" clearable />
          </el-form-item>
          <el-form-item label="工位全称">
            <el-input v-model.trim="filter.stationName" placeholder="请输入工位全称" clearable />
          </el-form-item>
          <el-form-item label="工位简称">
            <el-input v-model.trim="filter.stationShortName" placeholder="请输入工位简称" clearable />
          </el-form-item>
          <el-form-item label="工位类型">
            <el-select v-model="filter.stationType" placeholder="请选择工位类型" clearable>
              <el-option v-for="item in stationTypeOptions" :key="item.value" :label="item.label" :value="item.value" />
            </el-select>
          </el-form-item>
          <el-form-item label="工位状态">
            <el-select v-model="filter.stationStatus" placeholder="请选择工位状态" clearable>
              <el-option v-for="item in stationStatusOptions" :key="item.value" :label="item.label" :value="item.value" />
            </el-select>
          </el-form-item>
        </el-form>
      </template>
    </viewTable>
    <WorkStationEdit ref="workStationEdit" @save-success="loadData" />
  </div>
</template>

<script>
import viewTable from "@/components/ViewTable.vue";
import WorkStationEdit from "./WorkStationEdit";

export default {
  components: { viewTable, WorkStationEdit },
  data() {
    return {
      limits: {
        addAuth: this.$auth(155),
        editAuth: this.$auth(156),
        delAuth: this.$auth(157),
      },
      stationTypeOptions: [
        { label: "组装", value: 1 },
        { label: "SMT贴片", value: 2 },
        { label: "机加工", value: 3 },
        { label: "测试", value: 4 },
        { label: "包装", value: 5 },
        { label: "仓储分拣", value: 6 },
        { label: "检验", value: 7 },
      ],
      stationStatusOptions: [
        { label: "停用", value: 0 },
        { label: "正常", value: 1 },
        { label: "检修", value: 2 },
        { label: "调试中", value: 3 },
      ],
      filter: {
        stationCode: "",
        stationName: "",
        stationShortName: "",
        stationType: null,
        stationStatus: null,
      },
      columnsProperty: [
        { tooltip: true, key: "stationCode", width: 130, align: "center" },
        { tooltip: true, key: "stationName", minWidth: 180 },
        { tooltip: true, key: "stationShortName", width: 120 },
        { tooltip: true, key: "factoryName", width: 150 },
        { tooltip: true, key: "workshopName", width: 150 },
        { tooltip: true, key: "lineName", width: 150 },
        { tooltip: true, key: "stationTypeName", width: 100, align: "center" },
        { tooltip: true, key: "stationStatusName", width: 100, align: "center" },
        { tooltip: true, key: "createUserName", width: 100 },
        { tooltip: true, key: "createTime", width: 160, align: "center" },
        { key: "action", align: "center", width: 100, slot: "action" },
      ],
    };
  },
  methods: {
    loadData(pageNum) {
      this.$refs.viewTable.loadData(pageNum);
    },
    addEditHandle(row) {
      this.$refs.workStationEdit.open(row);
    },
    deleteHandle(row) {
      this.$http.delete("basic", "fm/workstation", row.id).then((resp) => {
        if (resp.success) {
          this.$message.success("删除成功");
          this.loadData();
        }
      });
    },
    resetHandle(filter) {
      this.filter = Object.assign(this.filter, filter);
    },
  },
};
</script>
